/* jshint browserify: true */
'use strict';

module.exports = {
    HIGHLITER_ACE: 'ace',
};
